import ReadOnly from './ReadOnly';

export default ReadOnly;
